import { render, staticRenderFns } from "./goodsRule.vue?vue&type=template&id=78543a5e&scoped=true"
import script from "./goodsRule.vue?vue&type=script&lang=js"
export * from "./goodsRule.vue?vue&type=script&lang=js"
import style0 from "./goodsRule.vue?vue&type=style&index=0&id=78543a5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78543a5e",
  null
  
)

export default component.exports